import { render, staticRenderFns } from "./MenuItemCard.vue?vue&type=template&id=21f0a1cb&scoped=true"
import script from "./MenuItemCard.vue?vue&type=script&lang=js"
export * from "./MenuItemCard.vue?vue&type=script&lang=js"
import style0 from "./MenuItemCard.vue?vue&type=style&index=0&id=21f0a1cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f0a1cb",
  null
  
)

export default component.exports